import React from "react";

export function Card({
  heading,
  title,
  children,
}: {
  heading?: React.ReactNode;
  title?: string;
  children: React.ReactNode;
}) {
  return (
    <div className="card">
      {heading}
      <div className="card-body">
        {title && <h5 className="card-title">{title}</h5>}
        {children}
      </div>
    </div>
  );
}
